// extracted by mini-css-extract-plugin
module.exports = {"layout":"main-5fd986f6f457b922240e872f462acc43","main":"main-a67eb714eb1b7fba4de7912ad97c93f4"};